export default __webpack_public_path__ + "static/media/Trophy.fc7c59b5.svg";